import { render, staticRenderFns } from "./TransactionTables.vue?vue&type=template&id=2ebf4511&scoped=true&"
import script from "./TransactionTables.vue?vue&type=script&lang=js&"
export * from "./TransactionTables.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTables.vue?vue&type=style&index=0&id=2ebf4511&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf4511",
  null
  
)

export default component.exports